import { kpiTracker } from '@/lib/kpiTracking';

interface ItemTypeFilterMetrics {
  filteredItemsCount: number;
  queryTime: number;
  itemType: 'build' | 'service';
  timestamp: number;
}

export class ItemTypeMonitor {
  private static instance: ItemTypeMonitor;
  private metrics: ItemTypeFilterMetrics[] = [];
  
  static getInstance() {
    if (!ItemTypeMonitor.instance) {
      ItemTypeMonitor.instance = new ItemTypeMonitor();
    }
    return ItemTypeMonitor.instance;
  }
  
  trackFilter(metrics: ItemTypeFilterMetrics) {
    this.metrics.push(metrics);
    
    // ✅ Light QA Contract: Track P95 latency
    const p95 = this.calculateP95();
    if (import.meta.env.DEV) {
      if (p95 > 200) { // 200ms threshold
        console.warn('[ITEM_TYPE] P95 latency high:', p95, 'ms');
      }
      
      // ✅ Log structured data
      console.log('[ITEM_TYPE_METRICS]', {
        type: metrics.itemType,
        count: metrics.filteredItemsCount,
        queryTime: metrics.queryTime,
        p95
      });
    }
    
    // Clean old metrics (keep last 100)
    if (this.metrics.length > 100) {
      this.metrics = this.metrics.slice(-100);
    }
  }
  
  calculateP95(): number {
    if (this.metrics.length === 0) return 0;
    const sorted = this.metrics.map(m => m.queryTime).sort((a, b) => a - b);
    const p95Index = Math.floor(sorted.length * 0.95);
    return sorted[p95Index] || 0;
  }
  
  getErrorRate(): number {
    // Calculate error rate from tracked metrics
    if (this.metrics.length === 0) return 0;
    // Placeholder - extend based on actual error tracking
    return 0;
  }
}

export const itemTypeMonitor = ItemTypeMonitor.getInstance();
